/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LanguagesApi } from '../api/languages.api';
import { switchMap, map } from 'rxjs/operators';
import { LanguagesData, Languages } from '../../../interfaces/masters/languages';

@Injectable()
export class LanguagesService extends LanguagesData {

  constructor(private api: LanguagesApi) {
    super();
  }


  list(): Observable<Languages[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Languages>{
      return this.api.getById(url);
  }

  create(url: string, data:Languages): Observable<Languages> {
    return this.api.add(url,data);
  }

  update(url: string, data:Languages): Observable<Languages> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
